import { Typography } from 'antd';
import Logo from '../../Logo';

/** Centered HouseWhisper-branded panel used by the landing / welcome screens. */
export function HeroPanel({
  title,
  subtitle,
  children,
  maxWidth = 640,
}: {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  maxWidth?: number;
}) {
  return (
    <div
      style={{
        maxWidth,
        margin: '0 auto',
        padding: '72px 24px',
        textAlign: 'center',
      }}
    >
      <Logo size={0.8} />
      <Typography.Title level={3} style={{ marginTop: 28 }}>
        {title}
      </Typography.Title>
      {subtitle && (
        <Typography.Paragraph style={{ marginBottom: 24 }} type="secondary">
          {subtitle}
        </Typography.Paragraph>
      )}
      {children}
    </div>
  );
}
